import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-address-details',
  templateUrl: './address-details.component.html',
  styleUrls: ['./address-details.component.css']
})
export class AddressDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
